import { type UseQueryResult, useQuery } from 'react-query';
import {
  FairValueService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto,
} from '../../services/wealthlane-award-services';

const useGetFairValueById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  payload: { awardId: string; awardType?: string }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const fairValueById = useQuery(['getFairValueById'], async () => {
    return await handleRequest(
      FairValueService.getApiAwardApiAppFairValueFairValueByAwardId(
        payload?.awardId,
        payload.awardType
      )
    );
  });

  return fairValueById;
};

export default useGetFairValueById;
